<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
      :backButton="true"
      :prevRoutePath="backUrl"
    />
    <div class="row">
      <div class="col-12" style="min-height: 50vh">
        <div class="card mb-4">
          <div class="card-body">
            <div class="media">
              <div class="avatar-sm mr-3">
                <span
                  class="
                    avatar-title
                    rounded-circle
                    bg-light
                    text-primary
                    border-primary
                    font-size-22
                  "
                >
                  <i class="bx bx-envelope bx-md"></i>
                </span>
              </div>
              <div class="media-body">
                <h5 class="mt-3">
                  {{ this.email }}
                </h5>
              </div>
            </div>
            <div v-if="loading" class="row mt-4 mx-auto">
              <div class="col-12">
                <div class="text-center">
                  <div
                    class="spinner-border text-secondary mb-4"
                    role="status"
                  ></div>
                </div>
              </div>
            </div>
            <div>
              <div class="row mt-4">
                <div
                  class="col-12 mb-4"
                  v-if="exposed.length != 0 && exposed[0].profile"
                >
                  <span>Related Target</span>
                  <div class="d-flex">
                    <div
                      class="social-source text-center mt-3 mx-2 px-2"
                      v-for="(tr, idx) in exposed[0].profile"
                      :key="idx"
                    >
                      <div class="avatar-sm mx-auto mb-3">
                        <img
                          :src="urlimage + tr.image_project"
                          class="rounded-circle avatar-sm m-1"
                          alt
                        />
                      </div>
                      <p class="text-muted mb-0">
                        {{ tr.title }}
                      </p>
                    </div>
                  </div>
                  <hr />
                </div>
                <div
                  v-for="(e, index) in exposed"
                  :key="index"
                  class="col-sm-3 py-2"
                >
                  <div class="d-block border border-primary rounded p-2 h-100">
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <h5 class="text-truncate">{{ e.source }}</h5>
                      <i
                        v-if="e.has_password == 0"
                        class="bx bxs-lock bx-sm"
                      ></i>
                      <i
                        v-if="e.has_password == 1"
                        class="text-success bx bxs-lock-open bx-sm"
                      ></i>
                    </div>
                    <hr />
                    <div class="text-xs">
                      <small v-if="e.has_password"
                        >Password : {{ e.password }}</small
                      ><br />
                      <small v-if="e.has_password"
                        >Password Hash : {{ e.hash }}</small
                      >
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 text-center" v-if="dnf">
                  <p class="text-secondary p-5">
                    {{ $t("overview.table.all.dnf") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import BreachService from "@/helpers/breach.service";

import appConfig from "@/app.config";

export default {
  page: {
    title: "Exposed Credential",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      backUrl: "/potential-breach",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: this.$t("advanced.exposed-credential"),
          href: "/potential-breach",
        },
        {
          text: "Detail",
          active: true,
        },
      ],
      email: this.$route.params.email,
      loading: false,
      dnf: false,
      exposed: [],
      title: this.$t("advanced.exposed-credential"),
      urlimage: process.env.VUE_APP_BASE_API_URL + "target/image-project?name=",
    };
  },
  methods: {
    getLocalData() {
      this.loading = true;
      BreachService.getBreach(this.email)
        .then((response) => {
          console.log(response);
          response.data.data.forEach((element) => {
            const mergeData = {
              ...element.breach,
              ...{ profile: element.profile },
            };

            this.exposed.push(mergeData);
          });
          // this.exposed = response.data.data;
          this.loading = false;
        })
        .catch((err) => {
          this.dnf = true;
          this.loading = false;
          console.log(err);
        });
    },
  },
  mounted() {
    this.getLocalData();
  },
};
</script>

<style scoped>
.loading {
  padding-top: 20%;
  padding-bottom: 20%;
}
</style>
